import gql from 'graphql-tag';
import React from 'react';
import {
  MyAccountCreditCardEditFormFields,
} from '../schemas/rql';
import CreditCardWalletRow, { CreditCardWalletRowFragment } from './credit_card_wallet_row';

type CreditCard = MyAccountCreditCardEditFormFields.CreditCards;

interface Props {
  creditCard: CreditCard;
}

export default function MyAccountCreditCardEditForm({ creditCard }: Props) {
  return (
    <CreditCardWalletRow creditCard={creditCard} />
  );
}

export const MyAccountCreditCardEditFormFragment = gql`
  fragment MyAccountCreditCardEditFormFields on rql_Me {
    creditCards {
      brand {
        type
        name
      }
      display {
        summary
      }
    }
    ...CreditCardWalletRowFields
  }
  ${CreditCardWalletRowFragment}
`;
